import api from '../token';

export const AlterServico = async (dados) => {
  try {
    const response = await api.post('/alterServico', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};




